import React, { useEffect, useState,useContext } from "react";
import {MenuItem,TextField,Grid,Paper,Typography, Button} from '@mui/material'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import RecursiveTreeView from "../Components/CheckedTreeView"
import CheckboxList from "../Components/CheckedTreeView"
import axios from "axios";
import { useUrlContext } from '../context/urlContext';
import { RenderTree, data } from "../Components/sampledata.ts";
import { errorContext } from "../Components/ErrorDisplay";
import { useAuth } from '../context/authContext';
import { useHistory } from "react-router-dom";

function PromotionLocationMap(props)
{
    const {user} = useAuth();
    const history = useHistory();
    const { UrlHelperObj } = useUrlContext();
    const {handleError} = useContext(errorContext);
    const[promoLocationTreeList,setPromoLocationTreeList]=useState(null);
    // start with null so we can detect "no selection yet" and auto-pick first
    const[selectedPromotion,setSelectedPromotion]=useState(null);
    const[promotionList,setPromotionList]=useState([]);
    const[partnerList,setPartnerList] = useState([]);
    const[brandList,setBrandList] = useState([]);
    const[selectedPartner,setSelectedPartner] = useState(null);
    const[selectedBrand,setSelectedBrand] = useState(null);
    const[selectedNodesInTree,setSelectedNodesInTree]= useState([]);
    const[isChange,setIsChange] = useState(false);
    const [isUnsavedDialogOpen, setIsUnsavedDialogOpen] = useState(false);
    useEffect(()=>{
        if (user && user.issuerId) {
            getPromotionList();
        }
    }, [user]);

    // when promotions arrive, pick the first one if none selected yet
    useEffect(()=>{
        if(promotionList.length > 0 && selectedPromotion === null)
        {
            const firstId = promotionList[0].id;
            setSelectedPromotion(firstId);
            getPromoLocationList(firstId);
        }
    },[promotionList, selectedPromotion]);
    function getAllMapped(promoLocationTreeList1){
       
            promoLocationTreeList1.forEach(element => {
                //console.log("RCV:"+JSON.stringify(element));
                if(element.mapped === true){
                    setSelectedNodesInTree(selectedNodesInTree => [...selectedNodesInTree,element]);
                    //console.log("MAPPED:"+JSON.stringify(element));
                }
                /* if(Array.isArray(element.children))
                {
                    getAllMapped(element.children);
                } */
            });
            
        }
        
    
    useEffect(()=>{
        if(promoLocationTreeList !== null && promoLocationTreeList !== undefined )
        {
            getAllMapped(promoLocationTreeList);
            //console.log("getAllMapped"+(selectedNodesInTree));
        }
    },[promoLocationTreeList]);

    
    async function getPartnerList()
    {
        await axios.get(UrlHelperObj.partnerUrl())
        .then(response => response.data)
        .then(results => {setPartnerList(results)})
        .catch(err => handleError(err));
    }
    async function getBrandList(id)
    {
        await axios.get(UrlHelperObj.brandUrl_GET(id))
        .then(response => response.data)
        .then(results => {setBrandList(results)})
        .catch(err => {setBrandList([])});
    }
    async function getPromotionList()
    {
        if (!user || !user.issuerId) {
            return;
        }

        await axios.get(UrlHelperObj.promotionUrlByStatus(user.issuerId, 1))
        .then(response => response.data)
        .then(results => {
            const list = Array.isArray(results) ? results : [];
            // Safety net: only show promotions for the active club. The request
            // already sends iId, but guard against the server returning others.
            const iid = String(user.issuerId);
            const promoIid = (p) => p?.issuer_id ?? p?.issuerId ?? p?.iId ?? p?.iid;
            const anyTagged = list.some(p => promoIid(p) !== undefined && promoIid(p) !== null);
            const scoped = anyTagged ? list.filter(p => String(promoIid(p)) === iid) : list;
            setPromotionList(scoped);
        })
        .catch(err => {setPromotionList([])});
    }
    async function getPromoLocationList(promoid)
    {
        await axios.get(UrlHelperObj.promotionLocationUrlByPromo(promoid,user.issuerId))
        .then(response => response.data)
        .then(results => {setPromoLocationTreeList(results.list); console.log(results)})
        .catch(err => handleError(err));

    }
    async function handleChangeInBrand(e)
    {
        setSelectedBrand(e.target.value);
        getPromotionList(e.target.value);
    }
     function handleChangeInPromotion(e)
    {
        if(isChange === true)
        {
            setIsUnsavedDialogOpen(true);
            return;
        }
        setSelectedNodesInTree([]);
        
        setSelectedPromotion(e.target.value);
        setPromoLocationTreeList(null);
        getPromoLocationList(e.target.value)
    }
    async function handleChangeInPartner(e)
    {
        setSelectedPartner(e.target.value);
        getBrandList(e.target.value);
    }
    function handleCancel()
    {
        history.push(user?.issuerId ? `/club/${user.issuerId}/home` : "/");
    }
    function handleCloseUnsavedDialog()
    {
        setIsUnsavedDialogOpen(false);
    }
    async function handleSubmit()
    {
        //console.log("SUBMIT:"+JSON.stringify(selectedPromotion))
        console.log("SUBMIT:"+JSON.stringify(selectedNodesInTree))
        var obj={
            promoid:selectedPromotion,
            issuerId:user.issuerId,
            locations:[]
        }
        selectedNodesInTree.forEach(element => {
            obj.locations.push(element);    
        });
        
        
        let isSuccess = true;
        await axios.post(UrlHelperObj.promotionLocationUrl(),obj)
        .then(response => response.data)
        .then(results =>console.log("Promotion location map successful"))
        .catch(err => {
            isSuccess = false;
            handleError(err);
        });

        if(!isSuccess)
            return;

        console.log("SUBMIT"+JSON.stringify(selectedNodesInTree));
        setSelectedNodesInTree([]);
        console.log("SUBMIT-DATA"+JSON.stringify(promoLocationTreeList));
        setIsChange(false);
        if(promotionList.length > 0)
        {
            const firstId = promotionList[0].id;
            setSelectedPromotion(firstId);
            setPromoLocationTreeList(null);
            getPromoLocationList(firstId);
            return;
        }
        setSelectedPromotion(null);
        setPromoLocationTreeList(null);
    }
    return(
    <Grid container spacing={2} style={{borderStyle:'none',borderColor:'black',justifyContent:'flex-start',marginLeft:10}} direction="row">
        <Grid container item xs={12} style={{textAlign:'left',borderStyle:'none',borderColor:'green'}}>
            <Grid item xs={12}>
            <Typography variant="h5" style={{ textAlign: 'left', marginBottom: 12 }}>Promotion Location Mapping</Typography>
            </Grid>
        </Grid>
        <Grid container item xs={12} spacing={2} direction="row">
            <Grid item alignItems="flex-start" container xs={12} md={4} direction="column" 
               style={{  borderStyle:'none',borderColor:'blue'}}>
            <Grid item container spacing={2} 
                style={{width:'100%',maxWidth:'320px',marginTop:'20px',marginLeft:10,borderStyle:'none',borderColor:'blue',justifyContent:'flex-start'}}>
                {/* <Grid item  style={{ width:'230px',  borderStyle:'none',borderColor:'blue'}}>
                    <TextField 
                        fullWidth
                        variant='outlined'
                        select
                        id='selectedPartner'
                        name='selectedPartner'
                        value={selectedPartner}
                        label="Select Partner"
                        onChange={handleChangeInPartner}
                        >
                        {partnerList &&
                            partnerList.map(type => (
                            <MenuItem value={type.id} key={type.id}>
                                {type.name}
                            </MenuItem>
                            ))}
                    </TextField>
                </Grid>
                <Grid item style={{width:'100%', maxWidth:'230px'}} >
                    <TextField 
                        fullWidth
                        variant='outlined'
                        select
                        id='selectedBrand'
                        name='selectedBrand'
                        value={selectedBrand}
                        label="Select Brand"
                        onChange={handleChangeInBrand}
                        >
                        {brandList &&
                            brandList.map(type => (
                            <MenuItem value={type.id} key={type.id}>
                                {type.name}
                            </MenuItem>
                            ))}
                    </TextField>
                </Grid> */}
                <Grid item xs={12}>
                    <TextField 
                        fullWidth
                        variant='outlined'
                        select
                        id='selectedPromotion'
                        name='selectedPromotion'
                        // if state is null, let value be "" to avoid uncontrolled warnings
                        value={selectedPromotion ?? ""}
                        label="Select Promotion"
                        onChange={handleChangeInPromotion}
                        >
                        {promotionList &&
                            promotionList.map(type => (
                            <MenuItem value={type.id} key={type.id}>
                                {type.name}
                            </MenuItem>
                            ))}
                    </TextField>
                    <Typography variant="caption" style={{ display: 'block', marginTop: 4, color: '#555' }}>
                        Only active and future promotions are listed.
                    </Typography>
                </Grid>
            </Grid>
            </Grid>
                <Grid item xs={12} md={8}
             style={{maxHeight:'420px',overflow:'auto',marginTop:'20px',  borderStyle:'none',borderColor:'red'}}>
                <Paper  >
                    <CheckboxList data={promoLocationTreeList} selectedList={selectedNodesInTree}
                            setSelectedList={setSelectedNodesInTree}  isChange={isChange}
                            setIsChange={setIsChange}/>
                {/* {promoLocationTreeList && 
                    <RecursiveTreeView 
                            //data={data}
                            data={promoLocationTreeList}
                            selectedList={selectedNodesInTree}
                            setSelectedList={setSelectedNodesInTree}
                            isChange={isChange}
                            setIsChange={setIsChange}
                            />} */}
                </Paper>
            </Grid>
        </Grid>
        <Grid container item direction="row" alignItems="center" xs={12} 
              style={{borderColor:'green',borderStyle:'none'}}>
            <Grid item xs={false} md={4}>

            </Grid>
            <Grid item alignItems="center" direction="row" xs={12} md={5} spacing={1}
                    container style={{marginTop:'20px',borderColor:'red',borderStyle:'none',justifyContent:'flex-start'}}>
                <Grid item style={{}}>
                <Button onClick={handleSubmit} disabled={!isChange?true:false} color="primary" variant="contained" >Submit</Button>
                </Grid>
                <Grid item>
                <Button onClick={handleCancel} color="secondary" variant="contained">Cancel</Button>
                </Grid>
            </Grid>
            <Grid item xs={false} md={3}></Grid>

        </Grid>
        <Dialog open={isUnsavedDialogOpen} onClose={handleCloseUnsavedDialog}>
            <DialogTitle>Unsaved Changes</DialogTitle>
            <DialogContent>
                <Typography>
                    Click <span style={{ fontWeight: 700, color: '#1976d2' }}>Submit</span> to save or <span style={{ fontWeight: 700, color: '#d32f2f' }}>Cancel</span>.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseUnsavedDialog} color="primary" variant="contained">OK</Button>
            </DialogActions>
        </Dialog>
    </Grid>);
}
export default PromotionLocationMap;
